import { render } from "./RecrutareDetails.vue?vue&type=template&id=19f6e644&scoped=true"
import script from "./RecrutareDetails.vue?vue&type=script&lang=js"
export * from "./RecrutareDetails.vue?vue&type=script&lang=js"

import "./RecrutareDetails.css?vue&type=style&index=0&id=19f6e644&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f6e644"]])

export default __exports__